import { getShop } from '@helpers/env'
import Translations from '@helpers/translations'

const ratings = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

const shop = getShop()

const formData = {
  handle: 'spoke-feedback',
  requestHandle: `/feedback/${shop}`,
  header: {
    title: Translations.localise('pages.feedback.title'),
    copy: Translations.localise('pages.feedback.byline.default')
  },
  content: [
    {
      id: 'email',
      question: Translations.localise('pages.feedback.email'),
      type: 'email',
      required: true,
      hidden: false,
      placeholder: 'Email*',

      answers: ['']
    },
    {
      id: 'how_likely_are_you_to_recommend',
      question: Translations.localise(
        'pages.feedback.questions.how-likely-are-you-to-recommend'
      ),
      type: 'bullet',
      name: 'Email',
      placeholder: 'Choose your answer',
      required: true,
      hidden: false,
      answers: ratings
    },
    {
      id: 'rate_fit',
      question: Translations.localise('pages.feedback.questions.rate-fit'),
      type: 'bullet',
      required: true,
      placeholder: 'Choose your answer',
      hidden: false,
      answers: ratings
    },
    {
      id: 'how_can_we_improve_fit',
      question: Translations.localise('pages.feedback.questions.improve-fit'),
      type: 'textarea',
      required: false,
      placeholder: 'Choose your answer',
      hidden: true,
      answers: ['']
    },
    {
      id: 'rate_delivery_and_customer_service',
      question: Translations.localise(
        'pages.feedback.questions.rate-delivery-and-customer-service'
      ),
      type: 'bullet',
      required: true,
      placeholder: 'Choose your answer',
      hidden: false,
      answers: ratings
    },
    {
      id: 'new_products',
      question: Translations.localise('pages.feedback.questions.new-products'),
      type: 'textarea',
      required: false,
      hidden: true,
      answers: ['']
    },
    {
      id: 'price_to_value',
      question: Translations.localise(
        'pages.feedback.questions.price-to-value'
      ),
      type: 'bullet',
      required: true,
      placeholder: 'Choose your answer',
      hidden: false,
      answers: ratings
    },
    {
      id: 'site_navigation',
      question: Translations.localise(
        'pages.feedback.questions.site-navigation'
      ),
      type: 'bullet',
      required: true,
      placeholder: 'Choose your answer',
      hidden: false,
      answers: ratings
    },
    {
      id: 'find_the_product_you_wanted',
      question: Translations.localise(
        'pages.feedback.questions.find-the-product-you-wanted'
      ),
      type: 'textarea',
      required: false,
      hidden: true,
      answers: ['']
    }
  ]
}

export default formData
